import Vue from 'vue';
import axios from 'axios';
import 'babel-polyfill';
import 'core-js'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue';
import router from './router';
import store from './_store';
import globals from './globals';
import moment from 'moment'
import {i18n} from "./plugins/i18n";
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
var VueCookie = require('vue-cookie');

axios.defaults.baseUrl = 'http://localhost:8010/1.0/';
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common.Authorization = token;
}
Vue.config.productionTip = false;
Vue.mixin({
  data: globals
})

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
});

Vue.filter('formatDateNoH', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
});
Vue.filter('findFather', function(item, type) {
  let company = item;
  while (true){
    if (company.type === type)
      return company.name;
    else if (company.father)
      company = company.father;
    else
      return ""
  }
});
Vue.use(BootstrapVue);
Vue.use(VueQuillEditor, /* { default global options } */)
Vue.use(VueCookie);

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app');
